
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSpeedFullUp as ObiSpeedFullUpElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-speed-full-up.js';
 
 
 

 
 export const ObiSpeedFullUp = createComponent({
   react: React,
   tagName: 'obi-speed-full-up',
   elementClass: ObiSpeedFullUpElement,
   events: {
     
   }
  });
 
 